import script from "./OfferRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferRequest.vue?vue&type=script&setup=true&lang=js"

import "./OfferRequest.vue?vue&type=style&index=0&id=4740f8dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4740f8dc"]])

export default __exports__